import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { initialState } from '../channelAddSlice'
import { BizChannelTypes } from '../../../Codes'
import { isNil } from 'lodash'

const fetchTalkChannels = createAxiosThunk(
  'channelAdd/fetchTalkChannels',
  (noArgs, { getState }) => {
    const { bizChannelType, bizChannelId } = getState().channel.channelAdd
    return api.channel.getTalkChannels(
      isNil(bizChannelId) && bizChannelType === BizChannelTypes.TALK_CHANNEL
    )
  }
)

fetchTalkChannels.reducers = builder => {
  builder.addCase(fetchTalkChannels.pending, state => {
    state.kakaoTalkChannels = initialState.kakaoTalkChannels
    state.isTalkChannelsLoading = true
  })

  builder.addCase(fetchTalkChannels.fulfilled, (state, { payload }) => {
    state.isTalkChannelsLoading = false
    state.kakaoTalkChannels = payload
      .map(({ uuid, profileImage, name }) => ({
        uuid,
        name,
        imgURL: profileImage.smallUrl,
        isSelected: false,
      }))
      .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
  })

  builder.addCase(fetchTalkChannels.rejected, (state, { payload }) => {
    state.apiError = payload
    state.isTalkChannelsLoading = false
  })
}

export default fetchTalkChannels
